import { Text } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import cn from 'clsx';
import * as React from 'react';

import BaseClickable from '@/components/ui/BaseClickable';
import { useDevices } from '@/utils/devices';

import s from './ToolCallHistoryLink.module.scss';

type Props = {
  label: string;
  onClick?: () => void;
  className?: string;
  beforeSlot?: React.ReactNode;
  afterSlot?: React.ReactNode;
  withAnimation?: boolean;
  withArrow?: boolean;
};

const ToolCallHistoryLink: React.FC<Props> = ({
  label,
  onClick,
  className,
  beforeSlot,
  afterSlot,
  withAnimation = false,
  withArrow = false,
}) => {
  const { isCompactViewport } = useDevices();

  if (!onClick) {
    return (
      <Text
        size={isCompactViewport ? 'xs' : 'sm'}
        c="dimmed"
        fw={500}
        className={cn(s.root, className, s.root__label, withAnimation && s['root_with-animation'])}
      >
        {label}
      </Text>
    );
  }

  return (
    <BaseClickable
      onClick={onClick}
      className={cn(s.root, className, withAnimation && s['root_with-animation'])}
      ariaLabel={label}
    >
      {beforeSlot && beforeSlot}
      <Text size={isCompactViewport ? 'xs' : 'sm'} c="blue" fw={500} className={s.root__label}>
        {label}
      </Text>
      {withArrow && <IconChevronRight size={16} className={s.root__arrow} />}
      {afterSlot && afterSlot}
    </BaseClickable>
  );
};

export default React.memo(ToolCallHistoryLink);
